
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "./apiConfig";

/**
 * Fetch and normalize bill headers from server.
 * @param {Function} [setBillHeaders] optional setter to update component state
 * @returns {Array<string>|null} normalized array of header strings or null on failure
 */
export const fetchBillHeaders = async (setBillHeaders) => {
  try {
    const societyName = localStorage.getItem("society");
    const token = localStorage.getItem("token");

    if (!token || !societyName) {
      toast.error("Missing society or token");
      console.warn("fetchBillHeaders: missing token or society:", { token, societyName });
      return null;
    }


    const response = await axios.post(
      `${BASE_URL}/dynamic-table/get-headers?societyName=${encodeURIComponent(societyName)}`,
      {}, 
      { headers: { Authorization: `Bearer ${token}` }, validateStatus: null }
    );

    if (response.status >= 400) {
      const serverMsg = typeof response.data === "string" ? response.data : (response.data?.message || JSON.stringify(response.data));
      toast.error(`Failed to fetch headers: ${serverMsg}`);
      return null;
    }

    let payload = response.data;
    let headersArray = null;

    if (Array.isArray(payload)) {
      headersArray = payload;
    } else if (payload && typeof payload === "object") {
      if (Array.isArray(payload.headers)) headersArray = payload.headers;
      else if (Array.isArray(payload.data)) headersArray = payload.data;
      else if (Array.isArray(payload.result)) headersArray = payload.result;
      else {
        const firstArray = Object.values(payload).find((v) => Array.isArray(v));
        if (Array.isArray(firstArray)) headersArray = firstArray;
      }
    }

    if (!Array.isArray(headersArray) || headersArray.length === 0) {
      console.warn("fetchBillHeaders: could not find header array in response", response.data);
      return null;
    }

    const normalized = headersArray.map((h) => (h == null ? "" : String(h).trim()));

    if (typeof setBillHeaders === "function") {
      try {
        setBillHeaders(normalized);
      } catch (e) {
        console.warn("fetchBillHeaders: setBillHeaders threw:", e);
      }
    }

    return normalized;
  } catch (error) {
    console.error("fetchBillHeaders: request failed", error?.response || error?.message || error);
    const serverMsg = error?.response?.data || error?.message || "Failed to fetch bill headers";
    toast.error(typeof serverMsg === "string" ? serverMsg : "Failed to fetch bill headers");
    return null;
  }
};
